(function () {
  if (window.FlowGabeAudio) return;

  var ROOT_SELECTOR = '[data-flow-gabe-audio]';
  var states = new WeakMap();

  function track(eventName, properties) {
    if (!eventName) return;

    window.igEvents = window.igEvents || [];
    window.igEvents.push({
      event: eventName,
      properties: properties || {},
    });
  }

  function setImage(image, source, alt) {
    if (!image || !source) return;

    if (!image.getAttribute('src')) {
      image.setAttribute('src', source);
    }

    if (alt) {
      image.setAttribute('alt', alt);
    }
  }

  function getToggleLabel(button, state) {
    var playLabel = button.getAttribute('data-play-label') || 'Play';
    var pauseLabel = button.getAttribute('data-pause-label') || 'Pause';

    return state.isPlaying ? pauseLabel : playLabel;
  }

  function isAudioControlEvent(event) {
    var target = event && event.target;

    return Boolean(target && target.closest && target.closest('[data-flow-gabe-audio-toggle]'));
  }

  function eventProperties(properties) {
    var result = {};

    Object.keys(properties || {}).forEach(function (key) {
      result[key] = properties[key];
    });

    return result;
  }

  function trackPlaybackStarted(state, source, properties) {
    state.hasStartedPlayback = true;

    if (source === 'autoplay' && !state.trackedAutoplayStarted) {
      state.trackedAutoplayStarted = true;
      track('flow_gabe_audio_autoplay_started');
    }

    if (source === 'interaction' && !state.trackedInteractionStarted) {
      state.trackedInteractionStarted = true;
      track('flow_gabe_audio_interaction_started', eventProperties(properties));
    }
  }

  function trackPlaybackBlocked(state, source, error, properties) {
    var details = eventProperties(properties);

    details.reason = error && error.name ? error.name : 'unknown';

    if (source === 'autoplay' && !state.trackedAutoplayBlocked) {
      state.trackedAutoplayBlocked = true;
      track('flow_gabe_audio_autoplay_blocked', details);
    }

    if (source === 'interaction' && !state.trackedInteractionBlocked) {
      state.trackedInteractionBlocked = true;
      track('flow_gabe_audio_interaction_blocked', details);
    }
  }

  function update(root) {
    var state = states.get(root);
    if (!state) return;

    state.isPlaying = Boolean(state.audio && !state.audio.paused && !state.audio.ended);
    root.classList.toggle('is-playing', state.isPlaying);
    root.classList.toggle('is-paused', !state.isPlaying);

    if (state.status) {
      if (state.isPlaying) {
        state.status.textContent = 'Playing now';
      } else if (state.autoplayBlocked) {
        state.status.textContent = 'Tap play to hear Gabe';
      } else {
        state.status.textContent = 'Paused';
      }
    }

    state.buttons.forEach(function (button) {
      var label = getToggleLabel(button, state);
      var text = button.querySelector('[data-flow-gabe-audio-label]');

      button.setAttribute('aria-label', label + ' Gabe audio');
      button.setAttribute('aria-pressed', state.isPlaying ? 'true' : 'false');

      if (text) {
        text.textContent = label;
      }
    });

    if (state.floating) {
      var shouldShowFloating = state.enabled && state.hasStartedPlayback && !state.rootVisible;

      if (shouldShowFloating) {
        if (!state.floating.classList.contains('is-visible')) {
          state.floating.getBoundingClientRect();
        }

        state.floating.classList.add('is-visible');
        state.floating.setAttribute('aria-hidden', 'false');
      } else {
        state.floating.classList.remove('is-visible');
        state.floating.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function ensureSources(root, state) {
    var audioSource = root.getAttribute('data-audio-src');
    var speakerSource = root.getAttribute('data-speaker-src');
    var speakerAlt = root.getAttribute('data-speaker-alt') || 'Gabe, founder of Flow';

    if (state.audio && audioSource && !state.audio.getAttribute('src')) {
      state.audio.setAttribute('src', audioSource);
      state.audio.load();
    }

    if (speakerSource) {
      state.speakers.forEach(function (speaker) {
        speaker.hidden = false;
      });

      setImage(state.speakerImage, speakerSource, speakerAlt);
      setImage(state.floatingImage, speakerSource, '');
    }
  }

  function play(root, source, properties) {
    var state = states.get(root);
    if (!state || !state.audio) return Promise.resolve(false);

    ensureSources(root, state);
    state.autoplayBlocked = false;

    if (state.audio.ended) {
      try {
        state.audio.currentTime = 0;
      } catch (error) {
        // Some browsers can reject seeks before media metadata is ready.
      }
    }

    var result;
    try {
      result = state.audio.play();
    } catch (error) {
      result = Promise.reject(error);
    }

    if (!result || typeof result.then !== 'function') {
      trackPlaybackStarted(state, source, properties);
      update(root);
      return Promise.resolve(true);
    }

    return result
      .then(function () {
        state.autoplayBlocked = false;
        trackPlaybackStarted(state, source, properties);
        update(root);

        return true;
      })
      .catch(function (error) {
        state.autoplayBlocked = source === 'autoplay' || source === 'interaction';
        update(root);
        trackPlaybackBlocked(state, source, error, properties);

        return false;
      });
  }

  function clearScrollStartTimer(state) {
    if (!state || !state.scrollStartTimer) return;

    window.clearTimeout(state.scrollStartTimer);
    state.scrollStartTimer = null;
  }

  function removeInteractionScrollStart(root) {
    var state = states.get(root);
    if (!state) return;

    clearScrollStartTimer(state);

    if (state.interactionScrollCleanup) {
      state.interactionScrollCleanup();
      state.interactionScrollCleanup = null;
    }
  }

  function removeInteractionStart(root) {
    var state = states.get(root);
    if (!state) return;

    clearScrollStartTimer(state);

    if (state.interactionStartCleanup) {
      state.interactionStartCleanup();
      state.interactionStartCleanup = null;
    }

    if (state.interactionScrollCleanup) {
      state.interactionScrollCleanup();
      state.interactionScrollCleanup = null;
    }

    state.interactionStartArmed = false;
    state.interactionStartPending = false;
  }

  function startFromInteraction(root, trigger, event) {
    var state = states.get(root);
    var isScrollStart = trigger === 'scroll';

    if (!state || !state.enabled || !state.interactionStartArmed) return;
    if (state.interactionStartPending) return;
    if (isAudioControlEvent(event)) return;

    state.interactionStartPending = true;

    if (isScrollStart) {
      removeInteractionScrollStart(root);
    } else {
      removeInteractionStart(root);
    }

    play(root, 'interaction', { trigger: trigger }).then(function (started) {
      state = states.get(root);
      if (!state) return;

      state.interactionStartPending = false;

      if (started) {
        removeInteractionStart(root);
      }
    });
  }

  function armInteractionStart(root) {
    var state = states.get(root);
    if (!state || state.interactionStartArmed) return;

    var startFromClick = function (event) {
      startFromInteraction(root, 'click', event);
    };
    var startFromKey = function (event) {
      startFromInteraction(root, 'key', event);
    };
    var startFromScrollEnd = function (event) {
      startFromInteraction(root, 'scroll', event);
    };
    var scheduleScrollStart = function (event) {
      if (!state.interactionStartArmed) return;

      clearScrollStartTimer(state);
      state.scrollStartTimer = window.setTimeout(function () {
        startFromInteraction(root, 'scroll', event);
      }, 600);
    };
    var hasScrollEnd = 'onscrollend' in window;

    state.interactionStartArmed = true;

    document.addEventListener('click', startFromClick, true);
    document.addEventListener('keydown', startFromKey, true);
    window.addEventListener('scroll', scheduleScrollStart, { passive: true });

    if (hasScrollEnd) {
      window.addEventListener('scrollend', startFromScrollEnd, true);
    }

    state.interactionStartCleanup = function () {
      document.removeEventListener('click', startFromClick, true);
      document.removeEventListener('keydown', startFromKey, true);
    };
    state.interactionScrollCleanup = function () {
      window.removeEventListener('scroll', scheduleScrollStart);

      if (hasScrollEnd) {
        window.removeEventListener('scrollend', startFromScrollEnd, true);
      }
    };
  }

  function pause(root, source) {
    var state = states.get(root);
    if (!state || !state.audio) return;

    state.audio.pause();
    state.autoplayBlocked = false;
    update(root);

    if (source === 'click') {
      track('flow_gabe_audio_pause_clicked');
    }
  }

  function toggle(root) {
    var state = states.get(root);
    if (!state || !state.audio) return;

    if (state.audio.paused || state.audio.ended) {
      removeInteractionStart(root);
      track('flow_gabe_audio_play_clicked');
      play(root, 'click');
    } else {
      pause(root, 'click');
    }
  }

  function init(root) {
    var existing = states.get(root);
    if (existing) return existing;

    var state = {
      enabled: false,
      rootVisible: true,
      isPlaying: false,
      hasStartedPlayback: false,
      autoplayBlocked: false,
      trackedEnabled: false,
      trackedAutoplayStarted: false,
      trackedAutoplayBlocked: false,
      trackedInteractionStarted: false,
      trackedInteractionBlocked: false,
      interactionStartArmed: false,
      interactionStartPending: false,
      interactionStartCleanup: null,
      interactionScrollCleanup: null,
      scrollStartTimer: null,
      audio: root.querySelector('[data-flow-gabe-audio-element]'),
      status: root.querySelector('[data-flow-gabe-audio-status]'),
      buttons: Array.prototype.slice.call(root.querySelectorAll('[data-flow-gabe-audio-toggle]')),
      speakers: Array.prototype.slice.call(root.querySelectorAll('[data-flow-gabe-audio-speaker], [data-flow-gabe-audio-floating-speaker]')),
      speakerImage: root.querySelector('[data-flow-gabe-audio-speaker-image]'),
      floating: root.querySelector('[data-flow-gabe-audio-floating]'),
      floatingImage: root.querySelector('[data-flow-gabe-audio-floating-image]'),
    };

    states.set(root, state);

    state.buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        toggle(root);
      });
    });

    if (state.audio) {
      state.audio.addEventListener('play', function () {
        state.autoplayBlocked = false;
        update(root);
      });
      state.audio.addEventListener('pause', function () {
        update(root);
      });
      state.audio.addEventListener('ended', function () {
        state.audio.pause();
        state.autoplayBlocked = false;
        update(root);
      });
    }

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.rootVisible = entry.isIntersecting;
            update(root);
          });
        },
        { threshold: 0.2 },
      );
      state.observer.observe(root);
    }

    update(root);
    return state;
  }

  function enable(options) {
    var opts = options || {};
    var roots = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(function (root) {
      var state = init(root);

      state.enabled = true;
      root.hidden = false;
      root.setAttribute('data-enabled', 'true');
      ensureSources(root, state);

      if (!state.trackedEnabled) {
        state.trackedEnabled = true;
        track('flow_gabe_audio_enabled');
      }

      update(root);

      if (opts.autoplay) {
        removeInteractionStart(root);
        play(root, 'autoplay');
      } else if (opts.startOnInteraction) {
        armInteractionStart(root);
      }
    });
  }

  function disable() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(function (root) {
      var state = init(root);

      removeInteractionStart(root);
      state.enabled = false;
      pause(root);
      root.hidden = true;
      root.setAttribute('data-enabled', 'false');
      update(root);
    });
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  window.FlowGabeAudio = {
    enable: enable,
    disable: disable,
  };

  ready(function () {
    Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).forEach(init);
  });
})();
